import React from 'react';

const LineFlexIcon = ({ height = 86, ...rest }) => {
  const lineHeight = height - 6;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height={height} viewBox={`0 0 8 ${height}`} fill="none" {...rest}>
      <path d="M4 0.333333C2.52724 0.333333 1.33333 1.52724 1.33333 3C1.33333 4.47276 2.52724 5.66667 4 5.66667C5.47276 5.66667 6.66667 4.47276 6.66667 3C6.66667 1.52724 5.47276 0.333333 4 0.333333Z" fill="#2857FC" />
      <path d={`M3.5 3L3.5 ${lineHeight}L4.5 ${lineHeight}L4.5 3L3.5 3Z`} fill="#2857FC" />
      <path d={`M3.64644 ${lineHeight}C3.84171 ${lineHeight + 0.19526} 4.15829 ${lineHeight + 0.19526} 4.35355 ${lineHeight}L7.53553 ${lineHeight - 2.82843}C7.73079 ${lineHeight - 3.02369} 7.73079 ${lineHeight - 3.34027} 7.53553 ${lineHeight - 3.53553}C7.34027 ${lineHeight - 3.73079} 7.02369 ${lineHeight - 3.73079} 6.82842 ${lineHeight - 3.53553}L4 ${lineHeight - 0.70711}L1.17157 ${lineHeight - 3.53553}C0.976307 ${lineHeight - 3.73079} 0.659725 ${lineHeight - 3.73079} 0.464463 ${lineHeight - 3.53553}C0.2692 ${lineHeight - 3.34027} 0.2692 ${lineHeight - 3.02369} 0.464463 ${lineHeight - 2.82843}L3.64644 ${lineHeight}Z`} fill="#2857FC" />
    </svg>
  );
};

export default LineFlexIcon;
